// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6340":"f66d4429738d4ece","7543":"0ca3a6f6363d1f18"}[chunkId] + ".css";
};